import { ErrorMessage } from "@hookform/error-message";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Link, useHistory, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { Alert, Form, FormGroup, Spinner } from "reactstrap";
import {
  Block,
  BlockContent,
  BlockHead,
  BlockTitle,
  Button,
  Icon,
  PreviewCard,
} from "../../components/Component";
import { Types, useUser } from "../../context/user";
import { POST } from "../../helper/api";
import { set } from "../../helper/auth";
import Logo from "../../images/logo.png";
import Head from "../../layout/head/Head";
import PageContainer from "../../layout/page-container/PageContainer";

const Login = () => {
  const history = useHistory();
  const { search } = useLocation();

  const [loading, setLoading] = useState(false);
  const [passState, setPassState] = useState(false);
  const [errorVal, setError] = useState("");
  const { errors, register, handleSubmit } = useForm();

  const {
    state: { user, token },
    dispatch: dispatchUser,
  } = useUser();

  useEffect(() => {
    if (user && token) {
      const redirect = new URLSearchParams(search).get("redirect");
      history.push(redirect || "/");
    }
  }, [user, token, search]);

  const onFormSubmit = (formData) => {
    setLoading(true);
    POST(`auth/login`, { ...formData, type: "client" }, {}, true)
      .then(({ data }) => {
        dispatchUser({
          type: Types.LOGIN,
          item: {
            token: data.token,
            user: data.data,
          },
        });
        set("ROLE", data.data.role);
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <React.Fragment>
      <Head title="Login" />
      <PageContainer>
        <Block className="nk-block-middle nk-auth-body  wide-xs">
          <div className="brand-logo pb-4 text-center">
            <Link to={process.env.PUBLIC_URL + "/"} className="logo-link">
              <img
                className="logo-light logo-img logo-img-lg"
                src={Logo}
                alt="logo"
              />
              {/* <img className="logo-dark logo-img logo-img-lg" src={LogoDark} alt="logo-dark" /> */}
            </Link>
          </div>

          <PreviewCard className="card-bordered" bodyClass="card-inner-lg">
            <BlockHead>
              <BlockContent>
                <BlockTitle tag="h4">Đăng nhập</BlockTitle>
              </BlockContent>
            </BlockHead>
            {errorVal && (
              <div className="mb-3">
                <Alert color="danger" className="alert-icon">
                  {" "}
                  <Icon name="alert-circle" /> {errorVal}{" "}
                </Alert>
              </div>
            )}
            <Form className="is-alter" onSubmit={handleSubmit(onFormSubmit)}>
              <FormGroup>
                <div className="form-label-group">
                  <label className="form-label" htmlFor="default-01">
                    Tài khoản
                  </label>
                </div>
                <div className="form-control-wrap">
                  <input
                    type="text"
                    id="default-01"
                    name="username"
                    ref={register({ required: "Vui lòng nhập thông tin" })}
                    className="form-control-lg form-control"
                  />
                  <ErrorMessage
                    errors={errors}
                    name={`username`}
                    render={({ message }) => (
                      <span className="invalid">{message}</span>
                    )}
                  />
                </div>
              </FormGroup>
              <FormGroup>
                <div className="form-label-group">
                  <label className="form-label" htmlFor="default-01">
                    Mật khẩu
                  </label>
                </div>
                <div className="form-control-wrap">
                  <a
                    href="#password"
                    onClick={(ev) => {
                      ev.preventDefault();
                      setPassState(!passState);
                    }}
                    className={`form-icon lg form-icon-right passcode-switch ${passState ? "is-hidden" : "is-shown"
                      }`}
                  >
                    <Icon name="eye" className="passcode-icon icon-show"></Icon>

                    <Icon
                      name="eye-off"
                      className="passcode-icon icon-hide"
                    ></Icon>
                  </a>
                  <input
                    type={passState ? "text" : "password"}
                    id="password"
                    name="password"
                    ref={register({ required: "Vui lòng nhập thông tin" })}
                    className={`form-control-lg form-control ${passState ? "is-hidden" : "is-shown"
                      }`}
                  />
                  <ErrorMessage
                    errors={errors}
                    name={`password`}
                    render={({ message }) => (
                      <span className="invalid">{message}</span>
                    )}
                  />
                </div>
              </FormGroup>
              <FormGroup>
                <Button
                  size="lg"
                  className="btn-block"
                  type="submit"
                  color="primary"
                >
                  {loading ? <Spinner size="sm" color="light" /> : "Đăng nhập"}
                </Button>
              </FormGroup>
            </Form>
          </PreviewCard>
        </Block>
      </PageContainer>
    </React.Fragment>
  );
};
export default Login;
